import { Lock } from 'lucide-react';
import { ContentListPage } from '../ContentListPage.js';
import { pagesApi, type PageRecord } from './pages-api.js';

/** Sahifalar ro'yxati (TZ 7.1). */
export function PagesListPage() {
  return (
    <ContentListPage<PageRecord>
      title="Sahifalar"
      collection="pages"
      contentApi={pagesApi}
      basePath="/pages"
      createLabel="Sahifa qo‘shish"
      emptyTitle="Hozircha sahifa yo‘q"
      emptyHint="«Sahifa qo‘shish» tugmasini bosing va bloklardan sahifa yig‘ing."
      columns={[
        {
          key: 'title',
          header: 'Sarlavha',
          render: (row) => (
            <span className="flex items-center gap-1.5 font-medium text-n-800">
              {row.title?.uz || '(nomsiz)'}
              {row.isSystem && (
                <span title="Tizim sahifasi — o‘chirib bo‘lmaydi">
                  <Lock className="size-3.5 text-n-400" aria-hidden />
                </span>
              )}
            </span>
          ),
        },
        {
          key: 'slug',
          header: 'Manzil',
          hideOnTablet: true,
          render: (row) => <code className="text-xs text-n-600">/{row.slug || ''}</code>,
        },
        {
          key: 'blocks',
          header: 'Bloklar',
          align: 'right',
          width: '90px',
          hideOnTablet: true,
          render: (row) => <span className="text-n-600">{row.blocks?.length ?? 0}</span>,
        },
      ]}
    />
  );
}
